<template>
  <b-card ref="qrCodeContainer" class="mb-3 shadow text-center">
    <div v-if="isLoading">
      <!-- LOADING -->
      <b-media class="text-center">
        <spinner height="128" width="128"></spinner>
      </b-media>
    </div>
    <b-img
      v-else-if="qrCodeString"
      id="qr-code"
      :src="'data:image/png;base64,' + qrCodeString"
      alt="QR Code"
    />
    <p v-else>{{ $t("qr-code-no-data") }}</p>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ClientService from "../../../../services/client";
import Spinner from "../../../Helpers/Spinner/Spinner.vue";
import store from "../../../../store";

export default {
  props: ["sectionTitle"],
  data() {
    return {
      qrCodeString: "",
      loading: true
    };
  },
  components: {
    Spinner
  },
  watch: {
    qrCodeString(newValue) {
      this.$emit("qrCodeString", newValue);
    }
  },
  created() {
    this.load();
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  methods: {
    ...mapActions("auth", ["handleAxiosErrors"]),
    load() {
      this.getQrCode();
    },
    getQrCode() {
      store.dispatch("SET_LOADING", true);
      ClientService.getQrCode()
        .then(response => {
          this.qrCodeString = response;
          store.dispatch("SET_LOADING", false);
        })
        .catch(function(error) {
          // handle error
          this.handleAxiosErrors(error);
        })
        .then(function() {
          // always executed
        });
    }
  }
};
</script>

<style>
#qr-code {
  max-width: 100%;
  min-width: 50%;
}
</style>
